import Page from '@admin/components/page'
import SignupPage from './signup_page'
import Referrals from './referrals'
import Overview from './overview'
import Payouts from './payouts'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.affiliate.team.title,
  manager: {
    path: `/admin/truevail/admin/affiliates/${resources.affiliate.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview affiliate={ resources.affiliate } />
      },
      {
        label: 't(Payouts)',
        path: '/payouts',
        panel: <Payouts affiliate={ resources.affiliate } />
      },
      {
        label: 't(Referrals)',
        path: '/referrals',
        panel: <Referrals affiliate={ resources.affiliate } />
      },
      {
        label: 't(Signup Page)',
        path: '/signup_page',
        panel: <SignupPage affiliate={ resources.affiliate } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  affiliate: `/api/admin/truevail/admin/affiliates/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
